import { RootTreeModelProvider } from "../RootTreeModelProvider/RootTreeModelProvider";
import ThemeContainer from "../ThemeProvider/ThemeProvider";
import React, { PropsWithChildren } from "react";

export const RootProvider = React.memo(
  (props: PropsWithChildren<{}>): JSX.Element => (
    <RootTreeModelProvider>
      <ThemeContainer>{props.children}</ThemeContainer>
    </RootTreeModelProvider>
  ),
  () => true
);
